module.exports = __webpack_public_path__ + "static/img/logo.7f9ce4a2.svg";